'use client';

import dynamic from 'next/dynamic';
import type { Property } from '@/data/properties';

// Leaflet touches window/document, so the map only renders client-side. Loading it
// with ssr:false keeps it out of the server bundle, and it sits below the fold so it
// never blocks the hero LCP.
const CabinsMapInner = dynamic(() => import('./CabinsMapInner'), {
  ssr: false,
  loading: () => (
    <div className="h-[360px] md:h-[440px] w-full rounded-xl bg-[#F0EDE5] animate-pulse" />
  ),
});

export default function CabinsMap({
  regionLabel,
  ctaLabel,
  cabins,
  pendingLabel,
  showCabinCards,
}: {
  regionLabel?: string;
  ctaLabel?: string;
  cabins: Pick<Property, 'slug' | 'name' | 'resort' | 'images'>[];
  pendingLabel?: string;
  showCabinCards?: boolean;
}) {
  return <CabinsMapInner regionLabel={regionLabel} ctaLabel={ctaLabel} cabins={cabins} pendingLabel={pendingLabel} showCabinCards={showCabinCards} />;
}
